<template>
  <ul>
    <li class="major-check-item major-check-item--group f-cb">
      <div class="f-cb cursor-pointer" @click="checkAll">
        <!--<i class="float_left checkbox"-->
           <!--:class="[checkAllType === 'none' ?-->
           <!--'r2-icon-toggle_check_box_outline_blank' :-->
           <!--(checkAllType === 'all' ? 'r2-icon-toggle_check_box' : 'r2-icon-toggle_indeterminate_check_box')]">-->
        <!--</i>-->
        <label class="w__checkbox" style="margin-right: 5px;" :class="{'is-checked': checkAllType === 'all', 'is-indeterminate': !['none', 'all'].includes(checkAllType)}">
          <span class="w__checkbox__input" :class="{'is-checked': checkAllType === 'all', 'is-indeterminate': !['none', 'all'].includes(checkAllType)}">
            <span class="w__checkbox__inner" @click.stop=""></span>
            <input type="checkbox" class="w__checkbox__original" value="">
          </span>
        </label>
        <span class="checkbox-label">{{typeObj.cn}}</span>
      </div>
    </li>
    <li v-for="(item) in source" class="major-check-item">
      <div class="f-cb cursor-pointer" @click="checkItem(item)">
        <!--<i :class="['float_left checkbox', item.checked ? 'r2-icon-toggle_check_box' : 'r2-icon-toggle_check_box_outline_blank']"></i>-->
        <label class="w__checkbox" style="margin-right: 5px;" :class="{'is-checked': item.checked}">
          <span class="w__checkbox__input" :class="{'is-checked': item.checked}">
            <span class="w__checkbox__inner" @click.stop=""></span>
            <input type="checkbox" class="w__checkbox__original" value="">
          </span>
        </label>
        <span class="checkbox-label">{{item.description}}</span>
      </div>
    </li>
  </ul>
</template>
<style lang="less" type="text/less">
  li.major-check-item{
    position: relative;
    width: 100%;
    height: 22px;
    line-height: 22px;
    margin-bottom: 8px;
    overflow: hidden;
    &>a{
      display: inline-block;
      &:link{
        color:rgba(33,37,48,0.8);
        span.checkbox-label{
          margin-left: 10px;
        }
        i.checkbox{
          font-size: 20px;
          &.r2-icon-toggle_check_box, &.r2-icon-toggle_indeterminate_check_box{
            color: #2079FA;
          }
          &.r2-icon-toggle_check_box_outline_blank{
            color:rgba(33,37,48,0.1);
          }
        }
      }
    }
    &.major-check-item--group{
      &>a{
        &:link{
          color:rgba(33,37,48, 1);
          i.checkbox{
            &.r2-icon-toggle_check_box_outline_blank{
              color:rgba(33,37,48,0.15);
            }
          }
        }
      }
      margin-bottom: 20px;
      color: #212530;
      font-size:16px;
      font-weight:500;
      height: 24px;
      line-height: 24px;
    }
  }
</style>
<script>
import {clone} from '@/assets/utils'
export default {
  name: 'MajorCheckList',
  props: {
    type: { // 数据类型 1: 清单 2: 定额 3: 组价
      type: Number,
      required: true
    },
    typeObj: {
      type: Object,
      default: () => {}
    },
    sourceList: { // 专业列表
      type: Array,
      default: () => []
    },
    checkedList: { // 已选择的专业
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      source: [],
      checkedObj: {},
      checkedLength: 0
    }
  },
  computed: {
    checkAllType () {
      let str = 'none'
      if (this.source.length) {
        if (this.checkedLength === this.source.length) {
          str = 'all'
        } else if (this.checkedLength) {
          str = 'some'
        }
      }
      return str
    }
  },
  created () {
    this.initCheckbox()
  },
  methods: {
    // 1. 初始化选择框
    initCheckbox () {
      this.checkedList.forEach((child) => {
        this.$set(this.checkedObj, child, true)
      })
      this.sourceList.forEach((item, idx) => {
        const temp = clone(item)
        if (this.checkedObj[item.catalogIdGuid]) {
          temp.checked = true
          this.checkedLength++
        } else {
          temp.checked = false
        }
        this.$set(this.source, idx, temp)
      })
      this.dealCheckedList()
    },
    // 2. 选中某个专业
    checkItem (item) {
      item.checked = !item.checked
      if (item.checked) {
        this.checkedLength++
      } else {
        this.checkedLength--
      }
      this.dealCheckedList()
    },
    // 3. 类型复选框选择
    checkAll () {
      let checked = false
      if (this.checkAllType === 'none') {
        checked = true
      }
      this.source.forEach((item, idx) => {
        this.$set(this.source, idx, Object.assign(item, {checked}))
      })
      if (checked) {
        this.checkedLength = this.source.length
      } else {
        this.checkedLength = 0
      }
      this.dealCheckedList()
    },
    // 4. 已选择列表变化时
    dealCheckedList () {
      const list = []
      this.source.forEach((item) => {
        if (item.checked) {
          list.push({
            dataType: this.type,
            catalogId: item.catalogIdGuid,
            catalogName: item.description
          })
        }
      })
      this.$emit('change', {type: this.type, list})
    }
  }
}
</script>

